import {
    FETCH_SUBMITTED_FOR_VERIFICATION_VISITS_ERROR, FETCH_SUBMITTED_FOR_VERIFICATION_VISITS_START, FETCH_SUBMITTED_FOR_VERIFICATION_VISITS_SUCCESS, LOCK_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS, SET_SUBMITTED_FOR_VERIFICATION_SEARCH_FILTER_AND_SORT, UNLOCK_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS, SET_SUBMITTED_FOR_VERIFICATION_VISIT_PAGINATION,
    LOCK_SUBMITTED_FOR_VERIFICATION_VISIT_START, VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS, VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR,
    LOCK_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR,
    RESET_SUBMITTED_FOR_VERIFICATION_VISIT_FILTER,

} from '../../actions/typist/typistSubmittedAction';
import { paginationSize } from '../../../constants/constants';
import _ from 'lodash';

const INIT_STATE = {
    error: "",
    loading: false,
    unlocking: false,
    message: '',
    pagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0,
    },
    visits: [],
    searchFilter: {
        searchText: "",
        risId: 1,
        mipIds: [],
        modalityIds: [],
        startDate: null,
        endDate: null,
    },
    sortConditions: [{ sortBy: "visitStart", dataType: "DATE", sortType: "desc" }],
    skippedVisits: []

};

const typistSubmittedReducer = (state = INIT_STATE, action) => {
    let newVisits;
    let index;
    switch (action.type) {
        case SET_SUBMITTED_FOR_VERIFICATION_SEARCH_FILTER_AND_SORT: {
            return {
                ...state,
                searchFilter: { ...state.searchFilter, ...action.payload.searchFilter },
                sortConditions: action.payload.sortConditions.length > 0 ? [...action.payload.sortConditions] : [],
                skippedVisits: action.payload.skippedVisits.length > 0 ? [...action.payload.skippedVisits] : []
            }
        }
        case FETCH_SUBMITTED_FOR_VERIFICATION_VISITS_START: {
            return { ...state, error: '', message: '', found: false, loading: true };
        }
        case FETCH_SUBMITTED_FOR_VERIFICATION_VISITS_SUCCESS: {
            return { ...state, error: '', message: '', found: false, loading: false, visits: action.visits };
        }
        case FETCH_SUBMITTED_FOR_VERIFICATION_VISITS_ERROR: {
            return { ...state, error: '', message: '', found: false, loading: false };
        }
        case LOCK_SUBMITTED_FOR_VERIFICATION_VISIT_START: {
            return { ...state, loading: true };
        }
        case LOCK_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS: {
            newVisits = [...state.visits];
            index = newVisits.findIndex(obj => obj.reportId === action.visit.reportId && obj.visitNo === action.visit.visitNo);
            if (index > -1) {
                newVisits.splice(index, 1, { ...newVisits[index], ...action.visit });
            }
            return { ...state, visits: [...newVisits] };
        }
        case LOCK_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR: {
            return { ...state, loading: false };
        }
        case UNLOCK_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS: {
            let newVisits = [...state.visits];
            index = newVisits.findIndex(obj => obj.reportId === action.visit.reportId && obj.visitNo === action.visit.visitNo);
            if (index > -1) {
                newVisits.splice(index, 1, { ...newVisits[index], lockedBy: null });
            }
            return { ...state, visits: [...newVisits] };
        }

        case SET_SUBMITTED_FOR_VERIFICATION_VISIT_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }
        case VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS:
        case VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR: {
            return { ...state, loading: false };
        }
        case RESET_SUBMITTED_FOR_VERIFICATION_VISIT_FILTER: {
            let newState = _.cloneDeep(state);
            newState.searchFilter.searchText = null;
            newState.searchFilter.startDate = null;
            newState.searchFilter.endDate = null;
            return { ...newState };
        }
        default:
            return state;
    }
}

export default typistSubmittedReducer;
